// modules
import * as R from 'ramda'
import { dbReducerNorm, findById, ReduxFindAllNorm } from '@weblite/persist'

const COLLECTION = 'wapps'

export const wappsView = () => ReduxFindAllNorm(COLLECTION)

export const wappByIdView = findById(COLLECTION)

export const wappNameByIdView = wappId => R.prop('name', wappByIdView(wappId))

export const wappWisIdByIdView = wappId => R.prop('wisId', wappByIdView(wappId))

export const wappInstantiableByIdView = wappId =>
  R.prop('instantiable', wappByIdView(wappId))

export const wappServIndexesByIdView = wappId =>
  R.prop('servIndexes', wappByIdView(wappId))

export const wappCustomizeArrayByIdView = wappId =>
  R.prop('customizeArray', wappByIdView(wappId))

export const wappInlineByIdView = wappId =>
  R.prop('inline', wappByIdView(wappId))

export const wappSizeByIdView = wappId =>
  R.pick(['width', 'height', 'heightSlope'], wappByIdView(wappId))

export const wappModesByIdView = R.compose(
  R.keys,
  R.propOr({}, 'servIndexes'),
  wappByIdView,
)

export const wappVersionByIdView = R.compose(R.prop('version'), wappByIdView)

export default dbReducerNorm(['main', COLLECTION])
